// extracted by mini-css-extract-plugin
export default {"popup":"SessionExpiredPopup__popup__ghAi4","icon":"SessionExpiredPopup__icon__gAe5L","mainText":"SessionExpiredPopup__mainText__NCYAT"};